<template>
  <BaseAthleteCard
    :id="id"
    :name="name"
    :avatar="avatar"
    :is-selected="isSelected"
  >
    <template slot="caption">
      <BaseAvatar
        :url="team.image_url"
        :size="20"
        is-lazy
      />
      {{ team.name[$i18n.locale] }}
      <span v-if="position">
        &nbsp;- {{ $t(`athlete.positions.${position.name}`) }}
      </span>
      <div>
        {{ $t('total-goals') }}: {{ score }}
      </div>
    </template>

    <template
      v-if="buttonPosition === 'left'"
      slot="left"
    >
      <span
        v-if="isAthleteAssignmentProcessing"
        :minHeight="25"
      >
        <BaseLoading :min-height="25" />
      </span>
      <BaseButton
        v-else
        :variant="addButtonVariant"
        font-size="small"
        is-rounded
        :is-disabled="!isSelected && !isPlayerSelectEnabled"
        @click="handleClick"
      >
        <span v-if="!isSelected">{{ $t('pick') }}</span>
        <span v-else>{{ $t('remove') }}</span>
      </BaseButton>
    </template>
    <template
      v-if="buttonPosition === 'right'"
      slot="right"
    >
      <span
        v-if="isAthleteAssignmentProcessing"
        :minHeight="25"
      >
        <BaseLoading :min-height="25" />
      </span>
      <BaseButton
        v-else
        :variant="addButtonVariant"
        font-size="small"
        is-rounded
        :is-disabled="!isSelected && !isPlayerSelectEnabled"
        @click="handleClick"
      >
        <span v-if="!isSelected">{{ $t('pick') }}</span>
        <span v-else>{{ $t('remove') }}</span>
      </BaseButton>
    </template>
  </BaseAthleteCard>
</template>

<script>
import { buildNotification } from '@/helpers/ui'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
import BaseAthleteCard from '@/components/Atoms/BaseAthleteCard'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'ThePickAthleteCard',
  components: {
    BaseAvatar,
    BaseAthleteCard,
    BaseButton,
    BaseLoading,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      required: false,
      default: () => {},
    },
    team: {
      type: Object,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
    avatar: {
      type: String,
      required: false,
      default: null,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    pickedPlayersCount: {
      type: Number,
      default: 0,
    },
    isPlayerSelectEnabled: {
      type: Boolean,
      default: true,
    },
    maximumPickedPlayersCount: {
      type: Number,
      required: false,
      default: 8,
    },
    buttonPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    isAthleteAssignmentProcessing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    addButtonVariant() {
      let variant = 'orange'
      if (this.isAthleteAssignmentProcessing) {
        variant = 'gray'
      } else if (!this.isSelected) {
        variant = 'outline-orange'
      }
      return variant
    },
  },
  methods: {
    handleClick() {
      if (this.isSelected) {
        this.$emit('onAthletePickRemove')
      } else {
        if (this.pickedPlayersCount === this.maximumPickedPlayersCount) {
          buildNotification(({
            title: this.$t('player-cannot-be-picked'),
            message: this.$t('your-team-already-has-8-players'),
          }))
        } else {
          if (this.pickedPlayersCount === 0) {
            if (process.env.VUE_APP_FACEBOOK_PIXEL_ID) {
              // eslint-disable-next-line no-undef
              fbq('trackCustom', 'PredictionStarted')
            }
            if (process.env.VUE_APP_TWITTER_PID) {
              // eslint-disable-next-line no-undef
              twttr.conversion.trackPid(process.env.VUE_APP_TWITTER_PID, { tw_sale_amount: 0, tw_order_quantity: 0 })
            }
          }
          if (this.pickedPlayersCount === this.maximumPickedPlayersCount - 1) {
            if (process.env.VUE_APP_FACEBOOK_PIXEL_ID) {
              // eslint-disable-next-line no-undef
              fbq('trackCustom', 'PredictionComplete')
            }
          }
          this.$emit('onAthletePick')
        }
      }
    },
  },
}
</script>
